import { faBook, faClock, faCalendarAlt, faCheck } from "@fortawesome/free-solid-svg-icons";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import RightContent from 'app/components/layouts/MenuRight/RightContent';
import FontAwesomeIcon from "app/components/layouts/Icons/FontAwesome";
import SelectForm from 'app/commons/components/SelectForm';
import SearchForm from 'app/commons/components/SearchForm';
import * as categoryConst from 'app/constants/categories';
import { withGlobalData } from 'app/utils/withGlobalData';
import Paginate from 'app/commons/components/Paginate';
import { ResultAPI } from 'app/requests/apiRequest';
import { buildParams } from 'app/utils/pagination';
import Image from 'app/components/layouts/Image';
import * as dateUtils from 'app/utils/dateUtils';
import Title from 'app/components/layouts/Title';
import { useTranslation } from 'next-i18next';
import useIsLogin from 'app/hooks/useIsLogin';
import * as testApi from 'app/requests/tests';
import { setNewParams } from 'app/utils/ga';
import { minuteTest } from 'app/utils/test';
import { useState, useMemo } from 'react';
import { useRouter } from 'next/router';
import { NextSeo } from 'next-seo';
import { Test } from 'types/test';

import dynamic from "next/dynamic";
const ModalLogin = dynamic(() => import("app/components/layouts/Modals/ModalLogin"), { ssr: false });

export default function Index({ tests }) {
  const [openModalLogin, setOpenModalLogin] = useState(false);
  const { t } = useTranslation();
  const isLogin = useIsLogin();
  const router = useRouter()

  const defaultParam = {
    keyword: router.query.keyword || '',
    tested: router.query.tested || '',
    page: router.query.page || 1
  };

  const [params, setParams] = useState(defaultParam);

  const optionTesteds = useMemo(() => {
    return (
      <>
        <option value="">{t('vocabulary.option_all')}</option>
        <option value="1">{t('listening.learned')}</option>
        <option value="2">{t('listening.unlearned')}</option>
      </>
    )
  }, [router.query.category, router.locale]);

  const setDataParams = (value: string | number, name: string, page: number | null = null) => {
    const newParams = setNewParams(setParams, params, value, name, page);
    router.push(`/speaking${buildParams(newParams)}`);
  }

  const goToDetail = (test: Test) => {
    if (!isLogin) {
      setOpenModalLogin(true);
      return;
    }

    router.push(`/speaking/${test.slug}`)
  }

  const listTests = () => {
    const lists = (tests?.data || []).map((test: Test) => {
      return (
        <div className="mb-3 wrap-box-content" key={test.id} onClick={() => goToDetail(test)}>
          <div className="d-flex ml-2">
            <Image
              width={50}
              height={50}
              className="d-none d-md-block mr-3 my-auto"
              alt={test?.title[router.locale || 'vi']}
              src='/images/commons/speaking.webp'
            />
            <div className="overflow-hidden">
              <div className="wrap-box-title text-left">
                {test?.title[router.locale || 'vi']}
              </div>
              <div className="text-dark d-flex fz-2">
                <div className="mr-2 p-1">
                  <FontAwesomeIcon className="text-success" icon={faBook} />
                  <span><b>&nbsp;{test.questions_count}</b>&nbsp;{t('tests.question')} </span>
                </div>
                <div className="mr-2 p-1">
                  <FontAwesomeIcon className="text-warning" icon={faClock} />
                  <span>
                    <b>&nbsp;{minuteTest(test.category_id, Number(test.questions_count))}</b>&nbsp;
                    {t('tests.minute')}
                  </span>
                </div>
                <div className="mr-2 p-1 calendar-test">
                  <FontAwesomeIcon className="text-info mr-1" icon={faCalendarAlt} />
                  <span>{dateUtils.format(test.created_at, 'DD-MM-YYYY')}</span>
                </div>
                {test?.activity && (
                  <div className="mr-2 p-1">
                    <FontAwesomeIcon className="text-success pr-1" icon={faCheck} />
                    <span>
                      {t('tests.done')}
                    </span>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      )
    })
    return lists;
  }

  return (
    <section className="box-card-area list-test">
      <NextSeo
        title={t('speaking.title')}
        description={t('description.description')}
      />
      <div className="container-md">
        <ModalLogin isOpen={openModalLogin} onClose={() => setOpenModalLogin(false)} />
        <div className="d-flex">
          <div className="box-news-area">
            <div className='content_inner'>
              <Title title={'speaking.title'} />
              <div className="my-3 row">
                <div className='mx-auto position-relative col-md-6'>
                  <SearchForm setDataParams={setDataParams} />
                </div>
                {isLogin &&
                  <div className='form-group col-md-6'>
                    <SelectForm
                      value={params.tested}
                      handleChange={(value: string) => setDataParams(value, 'tested', 1)}
                      options={optionTesteds}
                      showOptionBlank={false}
                    />
                  </div>
                }
              </div>
              {tests?.data?.length > 0 &&
                <div>
                  <div>
                    {listTests()}
                  </div>
                  <Paginate
                    data={tests}
                    handleChangePage={(page: number) => setDataParams(page, 'page')}
                  />
                </div>
              }
              {!tests?.data?.length &&
                <div className='text-danger text-center mt-3 text-size-xl'>
                  {t('commons.result_notfound')}
                </div>
              }
            </div>
          </div>
          <RightContent />
        </div>
      </div>
    </section>
  )
}

export const getServerSideProps = withGlobalData(async ({ locale, query, req }) => {
  try {
    const token = req.cookies['auth_token'];

    const [translations, tests] = await Promise.all([
      serverSideTranslations(locale, ['common']),
      testApi.getTests({
        ...query,
        category_id: categoryConst.SPEAK_BASIC,
        from: 'home_page',
        code: locale,
      }, token) as Promise<ResultAPI>
    ]);

    return {
      props: {
        ...translations,
        tests,
      }
    };
  } catch (error) {
    return { notFound: true };
  }
});
